// Virtualization constants
export const VIRTUALIZATION_THRESHOLD = 100
export const ROW_HEIGHT = 33

// UI constants
export const ANIMATION_DURATION = 2000
export const MIN_AVAILABLE_HEIGHT = 100
export const DEFAULT_MAX_HEIGHT = 300
